/**
 * @generated SignedSource<<5f63aed75fef30bd3bef05cef16207c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersMassageToNewsletterItemNewsletter$data = {
  readonly alternativeName: string;
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly entityId: string;
  readonly homepageDescription: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly summary: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpersMassageToNewsletterItemNewsletter";
};
export type helpersMassageToNewsletterItemNewsletter$key = {
  readonly " $data"?: helpersMassageToNewsletterItemNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersMassageToNewsletterItemNewsletter"
};

(node as any).hash = "e8a697054db5767779c5e7074164d5c5";

export default node;
